import React, { useEffect, useState } from 'react';
import { Button, Col } from 'reactstrap';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import EmptyStateImage from './components/Image';
import UnlockButton from './components/UnlockButton';

import { userHasFeature } from '../../helpers/Features';
import { APIgetFTPAccounts } from '../../api/Importers';

const EmptyFTPQueue = () => {
  const intl = useIntl();

  const [accountsTotal, setAccountsTotal] = useState(null);

  const fetchAccounts = () => {
    APIgetFTPAccounts({
      page: 1,
      per_page: 30,
    }).then((response) => {
      const { data } = response;
      if (data) {
        setAccountsTotal(data.meta.total);
      }
    });
  };

  useEffect(() => {
    if (userHasFeature('ftp')) fetchAccounts();
  }, []);

  return (
    <div className="empty-state-wrapper row align-items-center justify-content-center">
      <Col lg="5" xs="12">
        <h2>
          {userHasFeature('ftp') ? (
            intl.formatMessage({ defaultMessage: 'Your FTP queue is empty now' })
          ) : (
            intl.formatMessage({ defaultMessage: 'Import files to your workspace via FTP' })
          )}
        </h2>
        <div className="mt-4">
          {intl.formatMessage({ defaultMessage: 'Follow the progress of files imported via FTP.' })}
        </div>
        {userHasFeature('ftp') ? (
          <>
            <p className="mt-3 mb-2">
              {accountsTotal === 0 && (
                intl.formatMessage({
                  defaultMessage: 'You don\'t have any FTP accounts yet',
                }))}
              {accountsTotal > 0 && (
                intl.formatMessage({
                  defaultMessage: 'Start uploading or',
                }))}
            </p>
            {accountsTotal === 0 && (
              <Button
                color="primary"
                tag={Link}
                to="/admin/ftp-accounts#add"
              >
                {intl.formatMessage({ defaultMessage: 'Create your first FTP account' })}
              </Button>
            )}
            {accountsTotal > 0 && (
              <Button
                color="primary"
                tag={Link}
                to="/admin/ftp-accounts"
              >
                {intl.formatMessage({ defaultMessage: 'Manage your FTP accounts' })}
              </Button>
            )}
          </>
        ) : (
          <UnlockButton feature="ftp" />
        )}
      </Col>
      <EmptyStateImage imageUrl="/images/empty-pages/empty-ftp.png" height="high" />
    </div>
  );
};

export default EmptyFTPQueue;
